'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FeedbackBubble = function FeedbackBubble(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    d: "M2.00963 4L3.00963 4.00056V4H2.00963ZM5.70674 18.2929L4.99963 17.5858L5.70674 18.2929ZM3.70808 20.2916L4.41519 20.9987L3.70808 20.2916ZM19.9996 1H3.99963V3H19.9996V1ZM3.99963 1C2.34084 1 1.00963 2.35425 1.00963 4H3.00963C3.00963 3.44575 3.45843 3 3.99963 3V1ZM1.00963 3.99944L1.00098 19.5833L3.00098 19.5844L3.00963 4.00056L1.00963 3.99944ZM4.41519 20.9987L6.41385 19L4.99963 17.5858L3.00098 19.5844L4.41519 20.9987ZM6.41385 19H19.9996V17H6.41385V19ZM19.9996 19C21.6519 19 22.9996 17.6523 22.9996 16H20.9996C20.9996 16.5477 20.5473 17 19.9996 17V19ZM22.9996 16V4H20.9996V16H22.9996ZM22.9996 4C22.9996 2.34772 21.6519 1 19.9996 1V3C20.5473 3 20.9996 3.45228 20.9996 4H22.9996ZM6.41385 19H6.41385V17C5.88342 17 5.37471 17.2107 4.99963 17.5858L6.41385 19ZM1.00098 19.5833C0.999987 21.3657 3.15488 22.259 4.41519 20.9987L3.00098 19.5844H3.00098L1.00098 19.5833Z"
  }), React__default["default"].createElement("circle", {
    cx: "8.5",
    cy: "7.5",
    r: "1.5"
  }), React__default["default"].createElement("circle", {
    cx: "15.5",
    cy: "7.5",
    r: "1.5"
  }), React__default["default"].createElement("path", {
    d: "M8 12C8.26667 13 9.44 14 12 14C14.56 14 15.7333 13 16 12",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var FeedbackBubble$1 = iconStyles()(FeedbackBubble);

module.exports = FeedbackBubble$1;
